import React from 'react';
function Power({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v7.33" />
      <path strokeLinecap="round" d="M8.5 4.804a8 8 0 107 0" />
    </svg>
  );
}

export default Power;
